import React, { useState, useEffect, useCallback } from 'react';
import { withTranslation } from '../../ChildrenContext.js';
import PropTypes from 'prop-types';
import FormGroup from '../../FormGroup';
import ButtonsList from '../../ButtonsList';

const ConversionStatuses = ({ edit, statuses, onAction, t }) => {
    const [state, setState] = useState({
        edit: edit,
        statuses: statuses || []
    });

    useEffect(() => {
        setState(prevState => ({
            ...prevState,
            edit: edit,
            statuses: statuses || []
        }));
    }, [edit, statuses]);

    const onChange = useCallback((value) => {
        let newStatuses = [...state.statuses];
        let isAllActive = ['new', 'review', 'hold', 'confirmed', 'rejected'].every(item => newStatuses.includes(item));

        if (value === 'all') {
            newStatuses = isAllActive ? [] : ['new', 'review', 'hold', 'confirmed', 'rejected'];
        } else if (value && isAllActive) {
            newStatuses = [value];
        } else {
            const index = newStatuses.indexOf(value);
            index === -1 ? newStatuses.push(value) : newStatuses.splice(index, 1);
        }

        setState(prevState => ({
            ...prevState,
            statuses: newStatuses
        }));

        if (onAction) {
            onAction({ statuses: newStatuses });
        }
    }, [state.statuses, onAction]);

    const isChecked = useCallback((value) => {
        let checked = false;

        if (value && state.statuses.indexOf(value) !== -1 || !value && !state.statuses.length) {
            checked = true;
        }

        return checked;
    }, [state.statuses]);

    const staticNames = t?.postbackPage?.creatingEditing || {};

    return (
        <FormGroup
            fieldClass="input-wrapper"
        >
            <h3 className="bold subtitle">{staticNames.conversionStatusTitle}</h3>
            <ButtonsList
                fields={[{
                    key: 'status',
                    list: [
                        {value: 'all', title: staticNames.all},
                        {value: 'new', title: staticNames.new},
                        {value: 'review', title: staticNames.review},
                        {value: 'hold', title: staticNames.hold},
                        {value: 'confirmed', title: staticNames.confirmed},
                        {value: 'rejected', title: staticNames.rejected}
                    ],
                    label: staticNames.form?.status
                }]}
                data={{key: 'status'}}
                currentValue={state.statuses}
                multiOptions={true}
                onChange={onChange}
            />
        </FormGroup>
    );
};

ConversionStatuses.propTypes = {
    edit: PropTypes.bool,
    statuses: PropTypes.array,
    onAction: PropTypes.func,
    t: PropTypes.object
};

ConversionStatuses.defaultProps = {
    edit: false,
    statuses: [],
    onAction: () => {}
};

export default withTranslation(ConversionStatuses);